import { DossierIcon } from "@logora/parliament.icons.regular_icons";
import {
	formatActeur,
	formatChambre,
	formatDate,
	formatLabel,
	formatNumero,
	formatCell,
} from "../formatters";

const columns = [
	{
		header: "Chambre",
		accessorKey: "chambre",
		cell: (info) => formatChambre(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Chambre",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{
						value: "AN",
						label: "AN",
					},
					{
						value: "SN",
						label: "SN",
					},
				],
			},
		},
	},
	{
		header: "Déposé le",
		accessorKey: "dateDepot",
		cell: (info) => formatDate(formatCell(info)),
		defaultSorting: "desc",
		meta: {
			filter: {
				label: "Date de dépôt",
				variant: "date-range",
				labels: ["Après le", "Avant le"],
			},
		},
	},
	{
		header: "Type",
		accessorKey: "typeInitiative",
		cell: (info) => formatLabel(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Type",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{ value: "Proposition de loi", label: "Proposition de loi" },
					{ value: "Projet de loi", label: "Projet de loi" },
					{ value: "Commission d'enquête", label: "Commission d'enquête" },
					{
						value: "Proposition de résolution",
						label: "Proposition de résolution",
					},
					{ value: "Résolution", label: "Résolution" },
					{ value: "Rapport d'information", label: "Rapport d'information" },
				],
			},
		},
	},
	{
		header: "Auteur",
		accessorKey: "acteurPrincipalRef",
		cell: (info) => formatActeur(formatCell(info)),
		enableSorting: false,
	},
	{
		header: "Numéro",
		accessorKey: "numero",
		cell: (info) => formatNumero(formatCell(info)),
		meta: {
			filter: {
				label: "Numéro",
			},
		},
	},
	{
		header: "Nom",
		accessorKey: "titre",
		enableSorting: false,
	},
	{
		header: "Mise à jour",
		accessorKey: "dateDernierActe",
		cell: (info) => formatDate(formatCell(info)),
	},
	{
		header: "Statut",
		accessorKey: "statut",
		enableSorting: false,
		meta: {
			filter: {
				label: "Statut",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{
						value: "Texte déposé",
						label: "Texte déposé",
					},
					{
						value: "1ère lecture en commission",
						label: "1ère lecture en commission",
					},
					{
						value: "1ère lecture en séance publique",
						label: "1ère lecture en séance publique",
					},
					{
						value: "2ème lecture en commission",
						label: "2ème lecture en commission",
					},
					{
						value: "2ème lecture en séance publique",
						label: "2ème lecture en séance publique",
					},
					{
						value: "Discussion du texte de la CMP en séance publique",
						label: "Discussion du texte de la CMP en séance publique",
					},
					{
						value: "Saisine du conseil constitutionnel",
						label: "Saisine du conseil constitutionnel",
					},
					{ value: "Texte adopté", label: "Texte adopté" },
				],
			},
		},
	},
];

export const dossierDataset = {
	key: "dossiers",
	name: "Dossiers",
	columns: columns,
	filterMapping: {
		acteurRefUid: "acteurPrincipalRefUid",
		organeRefUid: "acteurPrincipalRef_groupeParlementaireUid",
		dossierRefUid: "uid",
	},
	include: [
		"acteurPrincipalRef.groupeParlementaire",
		"acteurPrincipalRef.mandatPrincipal",
		"documentDeposeRef",
		"alineas",
	],
	searchTable: "alineas",
	searchPlaceholder: "Rechercher un dossier...",
	icon: <DossierIcon width={20} height={20} />,
};
